// Filter state of the Gestiones IPC queue. Values are kept as strings exactly as the selects and inputs hold them;
// responsable "0" means "Sin asignar". In the Todas section a motive is "TIPO|CODE", because a code can repeat across
// types: the query splits it into motivoTipo and motivoCodigo.

export const VISTAS = {
  ACTIVAS: "activas",
  FINALIZADAS: "finalizadas",
};

export const PAGE_SIZE = 50;

// KPIs of the selected section and the server kpi filter each one applies (Activas clears it).
export const KPIS = [
  { key: "activas", label: "Activas", param: null },
  { key: "contactoVencido", label: "Contacto vencido", param: "VENCIDO" },
  { key: "paraHoy", label: "Para hoy", param: "HOY" },
  { key: "esperandoComercio", label: "Esperando al comercio", param: "ESPERANDO" },
  { key: "sinResponsable", label: "Sin responsable", param: "SIN_RESPONSABLE" },
  { key: "demoradas", label: "Demoradas", param: "DEMORADAS", warn: true },
];

export const kpiLabel = (param) => KPIS.find((item) => item.param && item.param === param)?.label || "";

export const EMPTY_FILTERS = {
  motivo: "",
  estado: "",
  kpi: "",
  resultado: "",
  canal: "",
  prioridad: "",
  responsable: "",
  origen: "",
  creadaDesde: "",
  creadaHasta: "",
  cierreDesde: "",
  cierreHasta: "",
};

const SHARED_KEYS = ["motivo", "canal", "prioridad", "responsable", "origen", "creadaDesde", "creadaHasta"];
const VIEW_KEYS = {
  [VISTAS.ACTIVAS]: ["kpi", "estado"],
  [VISTAS.FINALIZADAS]: ["resultado", "cierreDesde", "cierreHasta"],
};
const VIEW_ONLY_KEYS = Object.values(VIEW_KEYS).flat();

export const filterKeysFor = (vista) => [...(VIEW_KEYS[vista] || []), ...SHARED_KEYS];

// Switching views resets the filters that exist in only one of them (KPI, Estado, Resultado and the close range)
// and keeps the search and the shared filters, Prioridad included (Prompt 6).
export const resetViewFilters = (filters) => ({
  ...filters,
  ...Object.fromEntries(VIEW_ONLY_KEYS.map((key) => [key, EMPTY_FILTERS[key]])),
});

export const countActiveFilters = (filters, vista) => filterKeysFor(vista).filter((key) => filters[key]).length;

const splitMotivo = (value) => {
  const [first, second] = String(value).split("|");
  return second ? { motivoTipo: first, motivoCodigo: second } : { motivoCodigo: first };
};

export const buildListQuery = ({ vista, seccion, texto, filters, incluirHistorico = true, pagina, tamanoPagina = PAGE_SIZE }) => {
  const query = { vista, seccion, pagina, tamanoPagina };
  if (texto) query.texto = texto;
  if (filters.motivo) Object.assign(query, splitMotivo(filters.motivo));
  if (filters.canal) query.canal = filters.canal;
  if (filters.prioridad) query.prioridad = filters.prioridad;
  if (filters.responsable !== "") query.responsableUsuarioId = filters.responsable;
  if (filters.origen) query.origen = filters.origen;
  if (filters.creadaDesde) query.creadaDesde = filters.creadaDesde;
  if (filters.creadaHasta) query.creadaHasta = filters.creadaHasta;

  if (vista === VISTAS.FINALIZADAS) {
    if (filters.resultado) query.resultado = filters.resultado;
    if (filters.cierreDesde) query.cierreDesde = filters.cierreDesde;
    if (filters.cierreHasta) query.cierreHasta = filters.cierreHasta;
    query.incluirHistorico = incluirHistorico;
  } else {
    if (filters.kpi) query.kpi = filters.kpi;
    if (filters.estado) query.estado = filters.estado;
  }

  return query;
};

// "Exportar Excel" exports Finalizadas of the section with the same filters as the list ("Incluir históricas"
// included), without paging.
export const buildExportQuery = ({ seccion, texto, filters, incluirHistorico }) => {
  const { vista, pagina, tamanoPagina, ...query } = buildListQuery({
    vista: VISTAS.FINALIZADAS,
    seccion,
    texto,
    filters,
    incluirHistorico,
    pagina: 1,
  });
  return query;
};
